import PropTypes from "prop-types";
import { Switch, CircularProgress } from "@mui/material";

const TableHeading = ({ text }) => {
  return <span style={{ textTransform: "uppercase" }}>{text}</span>;
};

TableHeading.propTypes = {
  text: PropTypes.string.isRequired,
};

TableHeading.defaultProps = {
  text: "",
};

const TableStatusCell = ({ status, can_change, handleStatusToggle, loading }) => {
  return (
    <>
      {can_change ? (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Switch
            checked={status == true}
            onChange={handleStatusToggle}
            color="success"
            disabled={loading}
          />
          {loading && <CircularProgress size={15} style={{ marginLeft: 8 }} color="inherit" />}
        </div>
      ) : (
        <>
          {status == 1 ? (
            <span style={{ color: "green", fontWeight: "bold" }}>{t("lang.active")}</span>
          ) : (
            <span style={{ color: "red", fontWeight: "bold" }}>{t("lang.inactive")}</span>
          )}
        </>
      )}
    </>
  );
};

TableStatusCell.propTypes = {
  status: PropTypes.bool.isRequired,
  can_change: PropTypes.bool,
  handleStatusToggle: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

TableStatusCell.defaultProps = {
  can_change: false,
  loading: false,
};

const TableCodeCell = ({ text }) => {
  return (
    <pre>
      <code>{text}</code>
    </pre>
  );
};

TableCodeCell.propTypes = {
  text: PropTypes.string.isRequired,
};

TableCodeCell.defaultProps = {
  text: "",
};

export { TableHeading, TableStatusCell, TableCodeCell };
